export default "/wp-content/themes/onnit/script/cart/dist/tghUpsell-641fef82.jpg";